import React, { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const CONFIRM = {
  Complete: { title: "Mark this job as Complete?", body: "The job will be marked as finished. Only continue if all work has been done.", btn: "Yes, complete job", cls: "bg-emerald-600 hover:bg-emerald-700" },
  Cancelled: { title: "Cancel this job?", body: "The job will be marked as Cancelled. Only continue if the customer no longer wants this job.", btn: "Yes, cancel job", cls: "bg-rose-600 hover:bg-rose-700" },
};

export const JobStatusSelect = ({ value, options, disabled, onChange }) => {
  const [pending, setPending] = useState(null);
  const c = pending && CONFIRM[pending];
  const pick = (v) => { if (CONFIRM[v]) { setPending(v); } else { onChange(v); } };
  return (
    <>
      <Select value={value || undefined} disabled={disabled} onValueChange={pick}>
        <SelectTrigger className="h-9 w-44" data-testid="task-job-status"><SelectValue placeholder="—" /></SelectTrigger>
        <SelectContent>{options.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
      </Select>
      <AlertDialog open={!!pending} onOpenChange={(o) => { if (!o) { setPending(null); } }}>
        {c && (
          <AlertDialogContent data-testid="job-status-confirm-dialog">
            <AlertDialogHeader>
              <AlertDialogTitle>{c.title}</AlertDialogTitle>
              <AlertDialogDescription>{c.body}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="job-status-confirm-cancel">No, go back</AlertDialogCancel>
              <AlertDialogAction className={c.cls} data-testid="job-status-confirm-ok" onClick={() => { onChange(pending); setPending(null); }}>{c.btn}</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        )}
      </AlertDialog>
    </>
  );
};
